
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wideo/[slug]",
      function () {
        return require("private-next-pages/wideo/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wideo/[slug]"])
      });
    }
  